<template>
    <div>
        <v-navigation-drawer v-model="drawer" absolute temporary app>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>
                        <v-btn text @click="goTo('/')" class="text-black">
                            <img src="../../assets/logo/logo-panel2.png" class="logo-mobile title">
                        </v-btn>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list dense>
                <v-list-item link>
                    <v-btn text @click="goTo('/panel')" class="text-black link">
                        Harmonys
                    </v-btn>
                </v-list-item>

                <v-list-item link>
                    <v-btn @click="goTo('/panel/statistics')" text class="text-black link">
                        {{ $t('navbar.statistics') }}
                    </v-btn>
                </v-list-item>

                <v-list-item link>
                    <v-btn @click="goTo('/panel/withdrawals')" text class="text-black link">
                        {{ $t('navbar.withdrawals') }}
                    </v-btn>
                </v-list-item>

                <v-list-item link>
                    <v-btn @click="goTo('/panel/contacts')" text class="text-black link">
                        {{ $t('harmony.contactsTitle') }}
                    </v-btn>
                </v-list-item>

                <!--<v-list-item link class="mt-2" v-if="user">
                    <v-btn href="/panel" outlined color="black" class="text-black link ma-2 rounded-md py-4" small>
                        <v-icon left>
                            mdi-apps
                        </v-icon>
                        Harmonys
                    </v-btn>
                </v-list-item>-->

                <v-list-item link class="mt-2" v-if="user">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" color="red lighten-2" class="white--text link ma-2 rounded-md py-4" small @click="logout()">
                                <v-icon center color="white" size="20px" class="mr-1">
                                    mdi-power-plug-off-outline
                                </v-icon>
                                {{ $t('navbar.disconnect') }}
                            </v-btn>
                        </template>
                        <span>{{ $t('navbar.disconnect') }}</span>
                    </v-tooltip>
                </v-list-item>

                <v-list-item link class="mt-3">

                    <v-select v-model="locale" :items="locales" @change="changeLocale" :label="$t('navbar.language')"
                        class="ml-0 mr-3 col-12" outlined dense item-value="value" item-text="text" return-object>
                        <template v-slot:selection="{ item }">
                            <v-avatar size="24">
                                <img :src="item.flag" />
                            </v-avatar>
                            <span class="ml-2">{{ item.text }}</span>
                        </template>
                        <template v-slot:item="{ item }">
                            <v-avatar size="24">
                                <img :src="item.flag" />
                            </v-avatar>
                            <span class="ml-2">{{ item.text }}</span>
                        </template>
                    </v-select>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar color="white">
            <v-container>
                <v-row align="center" justify="space-between">
                    <div>
                        <v-btn text class="text-black" @click="goTo('/')">
                            <img src="../../assets/logo/logo-panel.png" class="logo">
                        </v-btn>
                        <!--<v-btn text href="/" class="text-black link hidden-sm-and-down">
                            {{ $t('navbar.home') }}
                        </v-btn>-->
                        <v-btn text class="text-black link hidden-sm-and-down" @click="goTo('/panel')">
                            Harmonys
                        </v-btn>
                        <v-btn text class="text-black link hidden-sm-and-down" @click="goTo('/panel/statistics')">
                            {{ $t('navbar.statistics') }}
                        </v-btn>

                        <v-btn text class="text-black link hidden-sm-and-down" @click="goTo('/panel/withdrawals')">
                            {{ $t('navbar.withdrawals') }}
                        </v-btn>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text class="text-black link hidden-sm-and-down" v-bind="attrs" v-on="on" @click="goTo('/panel/contacts')">
                                    {{ $t('harmony.contactsTitle') }}
                                </v-btn>
                            </template>
                            <span>WhatsApps y emails</span>
                        </v-tooltip>

                        <v-btn @click="impersonateAdmin()" small class="white--text link" color="#7343d9" v-if="admin">
                            <v-icon class="mr-2" small>mdi-tools</v-icon>
                            Admin
                        </v-btn>

                        <v-btn @click="toAdmin()" small class="white--text link" color="#7343d9" v-else-if="user.role_id == 1">
                            <v-icon class="mr-2" small>mdi-tools</v-icon>
                            Admin
                        </v-btn>
                    </div>
                    <v-row align="center" justify="end">

                        <transition name="fadeInDown">
                            <v-btn color="black" class="text-black link earing-outside ma-2 py-4" small @click="goTo('/panel/statistics')"
                                :loading="earnings_loading">
                                <v-icon size="18px">
                                    mdi-cash
                                </v-icon>
                                ${{ earnings ? earnings : '0.00' }}
                            </v-btn>
                        </transition>

                        <NotifyComponent/>

                        <template v-if="user">
                            <v-menu :nudge-width="200" offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        class="mx-2 btn-profile"
                                        fab
                                        dark
                                        outlined
                                        color="white"
                                    >
                                        <transition name="fadeInDown">
                                            <v-badge
                                                bordered
                                                bottom
                                                color="teal accent-3"
                                                dot
                                                offset-x="12"
                                                offset-y="12"
                                                v-if="user.logo_path"
                                            >
                                                <v-avatar size="49">
                                                    <v-img :src="user.logo_path"></v-img>
                                                </v-avatar>
                                            </v-badge>

                                            <v-badge
                                                bordered
                                                bottom
                                                color="teal accent-3"
                                                dot
                                                offset-x="12"
                                                offset-y="12"
                                                v-else
                                            >
                                                <v-avatar color="black" size="48">
                                                    <span class="white--text text-p">
                                                        {{ user.first_name.charAt(0) + user.last_name.charAt(0) }}
                                                    </span>
                                                </v-avatar>
                                            </v-badge>
                                        </transition>
                                    </v-btn>
                                </template>

                                <v-card>
                                    <v-list max-width="350" class="pa-0">
                                        <v-list-item class="pa-0">
                                            <v-list-item-content class="text-left pa-0">
                                                <div class="pa-4 py-0 d-flex justify-center align-center text-left" color="#8061C2">
                                                    <v-card class="px-2 py-0 mt-4 banner-modal">
                                                        <div class="d-flex flex-column">
                                                            <div class="d-flex justify-space-around align-center hover-info my-2 px-1">
                                                                <v-list-item-avatar height="40" width="40" class="my-1">
                                                                    <v-img cover :src="user.logo_path ? user.logo_path : require('../../assets/illustrations/no-photo.jpg')"/>
                                                                </v-list-item-avatar>
                                                                <v-list-item-subtitle class="name-label">{{user.first_name + " " + user.last_name}}</v-list-item-subtitle>
                                                            </div>
                                                            <!-- <hr style="border:none; height: 0.1px; background-color: #c1b5d3;">
                                                            <transition name="fadeInDown">
                                                                <v-btn outlined color="black" class="text-black link earing-rounded ma-2 py-4" small @click="goTo('/panel/statistics')"
                                                                    :loading="earnings_loading">
                                                                    <v-icon>
                                                                        mdi-cash
                                                                    </v-icon>
                                                                    ${{ earnings ? earnings : '0.00' }}
                                                                </v-btn>
                                                            </transition> -->
                                                        </div>
                                                    </v-card>
                                                </div>
                                                <div class="px-4">
                                                    <v-list-item-subtitle>
                                                        <v-btn @click="goTo('/panel/profile')" class="d-flex justify-left mt-3 px-2 item-list py-6"  plain>
                                                            <v-icon class="item-list_logo">mdi-cog</v-icon> Configuración de perfil
                                                        </v-btn>
                                                    </v-list-item-subtitle>

                                                    <v-list-item-subtitle>
                                                        <v-btn @click="logout()" class="d-flex justify-left my-3 px-2 item-list py-6"  plain >
                                                            <v-icon class="item-list_logo">mdi-logout</v-icon> Cerrar sesión
                                                        </v-btn>
                                                    </v-list-item-subtitle>

                                                </div>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>

                                    <v-divider></v-divider>

                                    <v-card-actions>
                                        <v-select hide-details v-model="locale" style="max-width: 170px;" :items="locales" @change="changeLocale" :label="$t('navbar.language')"
                                            class="my-3 px-3" outlined dense item-value="value" item-text="text" return-object>
                                            <template v-slot:selection="{ item }">
                                                <v-avatar size="24">
                                                    <img :src="item.flag" />
                                                </v-avatar>
                                                <span class="ml-2">{{ item.text }}</span>
                                            </template>
                                            <template v-slot:item="{ item }">
                                                <v-avatar size="24">
                                                    <img :src="item.flag" />
                                                </v-avatar>
                                                <span class="ml-2">{{ item.text }}</span>
                                            </template>
                                        </v-select>
                                        <v-spacer></v-spacer>
                                      <!-- <v-btn
                                          color="#8e84c0"
                                          to="/panel/profile"
                                          text
                                      >
                                         {{ $t('navbar.editProfile') }}
                                      </v-btn> -->

                                        <template v-if="user">
                                            <transition name="fadeInDown">
                                                <v-btn outlined color="black" class="ma-2 rounded-md py-4 earing-rounded" small @click="goTo('/panel/statistics')"
                                                    :loading="earnings_loading">
                                                    <v-icon class="ma-0">
                                                        mdi-cash
                                                    </v-icon>
                                                    ${{ earnings ? earnings : '0.00' }}
                                                </v-btn>
                                            </transition>
                                        </template>
                                    </v-card-actions>
                                </v-card>
                            </v-menu>
                        </template>
                        <v-btn text icon @click.stop="drawer = !drawer" color="black" class="hidden-md-and-up">
                            <v-icon>mdi-menu</v-icon>
                        </v-btn>
                    </v-row>
                </v-row>
            </v-container>
        </v-app-bar>
    </div>
</template>

<script>
    import axios from '@/axios.js';
    import NotifyComponent from '@/components/partials/admin/NotifyComponent.vue';

    export default {
        name: 'PanelNavBar',
        components: {
            NotifyComponent
        },
        data () {
            return {

                menu: false,
                drawer: null,
                locale: null,
                locales: [
                    { value: 'en', text: 'English', flag: require('@/assets/flags/usa.png') },
                    { value: 'es', text: 'Español', flag: require('@/assets/flags/spain.png') }
                ],
                show1: false,
                user: null,
                admin: null,
                earnings_loading: false,
                earnings: 0
            }
        },

        computed: {
        },

        created() {
            this.setLanguage()
            this.checkUser()
            this.getEarnings()
        },

        beforeDestroy() {
            this.$root.$off('user-updated', this.updateUser);
            this.$root.$off('EarningsUpdated', this.getEarnings);
            window.removeEventListener('storage', this.syncUserWithLocalStorage);
        },

        mounted() {
            this.$root.$on('user-updated', this.updateUser);
            this.$root.$on('EarningsUpdated', this.getEarnings);
            window.addEventListener('storage', this.syncUserWithLocalStorage);
        },
        methods: {
            updateUser(updatedUser) {
                this.user = updatedUser;
            },
            syncUserWithLocalStorage() {
                const user = localStorage.getItem("user");
                if (user) {
                    this.user = JSON.parse(user);
                }
            },

            handlePanel() {
                this.panel();
            },

            toAdmin(){
                window.location.href = this.$router.resolve({ path: '/panel/admin' }).href;
            },

            goTo(url){
                this.$router.push(url);
            },

            checkUser(){
                let user = localStorage.getItem("user");
                let admin = localStorage.getItem("impersonate_admin");
                if (user){
                    this.user = JSON.parse(user);
                    this.admin = JSON.parse(admin);
                }
            },

            async impersonateAdmin() {
                try {
                    const response = await axios.post('impersonate-admin', { admin: this.admin});

                    // Guardar el nuevo token y datos de usuario en el local storage
                    localStorage.removeItem("impersonate_admin");
                    localStorage.setItem("user", JSON.stringify(response.data.user));
                    localStorage.setItem("token", response.data.token);

                    this.$vs.notify({
                        title: 'Impersonación exitosa',
                        text: `Ahora estás logueado como ${response.data.user.first_name}`,
                        color: 'success',
                        icon: 'check_box',
                        position: 'bottom-center',
                        time: 5000,
                    });

                    //this.$router.push('/panel/admin');
                    window.location.href = this.$router.resolve({ path: '/panel/admin' }).href;
                } catch (error) {
                    this.$vs.notify({
                        title: 'Ha ocurrido un error',
                        text: 'No se pudo impersonar',
                        color: 'danger',
                        icon: 'warning',
                        position: 'bottom-center',
                    });
                    console.error(error);
                }
            },

            logout() {
                try {
                        axios.get('/logout');

                        localStorage.removeItem("user");
                        localStorage.removeItem("token");

                        this.$vs.notify({
                            title: this.$t('navbar.disconnection'),
                            text: this.$t('navbar.disconnection-desc'),
                            color: 'success',
                            icon: 'check_box',
                            position: 'bottom-center',
                            time: 5000,
                        });
                        // Redirigir a la página principal y recargar
                        //window.location.href = "/";
                        this.$router.push('/');
                } catch (error) {
                    console.error(error);
                }
            },

            changeLocale() {
                this.$i18n.locale = this.locale.value;
                localStorage.setItem('locale', this.locale.value);
                this.$root.$emit('languageChanged', this.locale.value);
                this.$vs.notify({
                    title: this.$t('navbar.language'),
                    text: this.$t('navbar.language-success'),
                    color: 'success',
                    icon: 'check_box',
                    position: 'bottom-center',
                    time: 5000,
                })
            },

            async getEarnings() {
                this.earnings_loading = true
                try {
                    const response = await axios.get("get-earnings");
                    if (response){
                        this.earnings = response.data.total_value
                        this.earnings_loading = false
                    }
                } catch (error) {
                    console.error("Error:", error);
                }
            },

            setLanguage(){
                const storedLocale = localStorage.getItem('locale');
                if (storedLocale) {
                    this.locale = (storedLocale == 'es') 
                        ? { value: 'es', text: 'Español', flag: require('@/assets/flags/spain.png') } 
                        : { value: 'en', text: 'English', flag: require('@/assets/flags/usa.png') };
                    this.$i18n.locale = storedLocale;
                } else {
                    const browserLocale = navigator.language.slice(0, 2);
                    if (browserLocale === 'en' || browserLocale === 'es') {
                        this.locale = (browserLocale == 'es') 
                            ? { value: 'es', text: 'Español', flag: require('@/assets/flags/spain.png') } 
                            : { value: 'en', text: 'English', flag: require('@/assets/flags/usa.png') };
                        this.$i18n.locale = browserLocale;
                        localStorage.setItem('locale', browserLocale);
                    } else {
                        this.locale = { value: 'es', text: 'Español', flag: require('@/assets/flags/spain.png') };
                        this.$i18n.locale = 'es';
                        localStorage.setItem('locale', 'es');
                    }
                }
            },
        }
    };
</script>

<style scoped>
    .item-list{
        width: 100%;
        border-radius: 12px;
        transition: 0.25s;
        text-align: left;
        color: #312083 !important;
    }

    .item-list i{
        border-radius: 100%;
        border-radius: 100%;
        background: #8e84c01a;
        padding: 5px;
        margin-right: 5px;
        transition: 0.25s;
        color: #8e84c0;
    }

    .item-list:hover i{
        color: white;
        background: rgba(255, 255, 255, 0.26);
    }

    .item-list:hover{
        background-color: #cec2e9;
        color:white !important;
    }

    .hover-info{
        padding: 0px 10px;
        transition: 0.25s;
        background-color: #e9e9e927;
        border-radius: 4px;
    }

    .hover-info:hover{
        border-radius: 5px;
        background-color: #e9e9e950;
    }

    .name-label{
        color: white !important;
        width: 100%!important;
        min-width: fit-content;
    }

    .v-menu__content{
        box-shadow:
            0px -2px 5px -3px rgba(0, 0, 0, 0.14),
            0px 5px 5px -3px rgba(0, 0, 0, 0.2),
            0px 8px 10px 1px rgba(0, 0, 0, 0.14),
            0px 3px 14px 2px rgba(0, 0, 0, 0.12);
    }
    .earing-rounded{
        border: none;
        color:#8061C2 !important;
    }

    .earing-outside{
        color:#fff !important;
        padding: 5px 10px  !important;
        background:#7343d9 !important;
        font-size: 12px;
    }

    .v-menu__content {
        border-radius: 16px !important;
    }

    .banner-modal {
        width: 100%;
        background-color: #8061C2;
        color: white;
        font-size: 15px !important;
        font-weight: 600 !important;
        box-shadow: 0 2px 12px rgba(0,0,0,0.4)!important;
    }
    .banner-modal div{
        width: 100%;
    }

    .desc {
        color: #9390a1;
    }

    .logo {
        width: 24px;
    }

    .logo-mobile {
        margin-left: -24px;
        width: 172px;
    }

    .title {
        font-size: 25px !important;
        text-transform: none !important; /* Evita la transformación a mayúsculas */
    }

    .link {
        text-transform: none !important;
    }

    .container {
        margin-top: 18px;
        max-width: 1100px !important;
    }

    header {
        height: 86px !important;
    }

    .border {
        border-color: gray;
        border-style: solid;
        border-width: 1px;
    }

    .btn-profile{
        width: fit-content;
        height: fit-content;
    }

    .gradient {
        width: 185px;
        padding: 8px;
        border-radius: 9px;
        background: #8e84c0;
        background: -moz-linear-gradient(90deg, #8e84c0 0%, rgb(236, 196, 255) 100%);
        background: -webkit-linear-gradient(90deg, #8e84c0 0%, rgb(236, 196, 255) 100%);
        background: linear-gradient(90deg, #8e84c0 0%, rgb(236, 196, 255) 100%);
        filter: progid: DXImageTransform.Microsoft.gradient(startColorstr="#8e84c0", endColorstr="rgb(236, 196, 255)", GradientType=1);
    }

    @media (max-width: 959px) {
        .logo {
            margin-left: -8px;
        }
    }

    .menu-grid{
        background:#8e84c052 ;
        padding: 0;
        margin-right: 6px;
        max-width: 48px;
        max-height: 48px;
    }
    .notify-panel{
        background: #8e84c0 !important;
    }
</style>

<style>

    .earing-outside span{
        gap: 5px;
    }

    .item-list span{
        justify-content: start !important;
    }
    .earing-rounded .v-btn__content{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px;
    }

    .earing-rounded .v-btn__content i{
        margin-right: 7px !important;
        font-size: 20px;
    }

</style>